module.exports = __webpack_public_path__ + "static/logo-color-no-bg-214d880d0acb943f565869adc77a4a21.png";